import React from "react"
import { Row, Col } from "react-bootstrap"
import { Typography, Slider } from "@mui/material";

export default function OverlayDimensions(props) {
  const {
    overlayDimensionLabel,
    transparentFocus,
    transparentFocusClass,
    transparentSettings,
    slideLayout,
    overlayDimensionValue,
    setTransparentSettings,
    setTransparentFocus,
    setOverlayDimensionValue,
    min,
    max,
    steps,
  } = props;

  let _min = min ?? 30;
  let _max = max ?? 70;
  let _steps = steps ?? 5;
  let marks = true;

  const formatValueLabel = (value) => {
    if (slideLayout.id === "image-with-horizontal-overlay") {
      return value < 20 ? 'Auto' : value;
    } else {
      return value;
    }
  };

  const horizontalOverlayMarks = [
    {
      value: 15,
    },
    {
      value: 20,
    },
    {
      value: 25,
    },
    {
      value: 30,
    },
    {
      value: 35,
    },
    {
      value: 40,
    },
    {
      value: 45,
    },
    {
      value: 50,
    },
    {
      value: 55,
    },
    {
      value: 60,
    },
    {
      value: 65,
    },
    {
      value: 70,
    },
  ]

  if (slideLayout.id === "image-with-horizontal-overlay") {
    marks = [...horizontalOverlayMarks];
    _steps = null;
    _min = 15;
    _max = 70;
  }

  return (
    <Col className="slide-option">
      <Row
        className={`mb-3 py-1 ${transparentFocus === transparentFocusClass
          ? "transparent-focus"
          : transparentSettings
            ? "transparent-opacity"
            : ""
          }`}
      >
        <Col className="label-container d-flex align-items-center">
          <Typography variant="form-group-label" owner="admin">
            {overlayDimensionLabel}
          </Typography>
        </Col>
        <Col>
          <Slider
            value={overlayDimensionValue}
            marks={marks}
            step={_steps}
            min={_min}
            max={_max}
            valueLabelDisplay="auto"
            valueLabelFormat={formatValueLabel}
            onChange={(e) => {
              setOverlayDimensionValue(e.target.value);
            }}
            onMouseDown={() => {
              setTransparentSettings(true);
              setTransparentFocus(transparentFocusClass);
            }}
            onChangeCommitted={() => {
              setTransparentSettings(false);
              setTransparentFocus("");
            }}
          />
        </Col>
      </Row>
    </Col>
  )
}